//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { fetchInstoreThemesAsync } from "./instoreThemesSlice";
import { useEffect } from "react";
import InstoreThemesContainer from "../../components/instoreThemes/InstoreThemesContainer";
//#endregion

export default function InstoreThemesPage() {
  //#region SETUP
  const dispatch = useAppDispatch();
  const { instoreThemes_Loaded } = useAppSelector(
    ({ instoreThemes }) => instoreThemes
  );
  //#endregion

  //#region LOGIC
  useEffect(() => {
    const fetchOnload = async () => {
      if (!instoreThemes_Loaded) {
        await dispatch(fetchInstoreThemesAsync());
      }
    };
    fetchOnload();
  }, [instoreThemes_Loaded, dispatch]);
  //#endregion

  return <InstoreThemesContainer />;
}
